import { NavItem } from '@/components/Sidebar/sidebar.types';
import { getPrevOrigin } from '@/config/prevOrigin';
import {
  Boxes,
  CheckSquare,
  Hammer,
  LayoutDashboard,
  Truck,
  UserCog,
  Wrench,
} from 'lucide-react';

/**
 * Screens web-next lacks link to the previous application (`href`); see
 * config/prevOrigin.ts for where that lives.
 */
const prev = getPrevOrigin();

const navMenu: NavItem[] = [
  {
    title: 'Dashboard',
    url: '/dashboard',
    icon: LayoutDashboard,
    isActive: true,
  },
  {
    title: 'Projects',

    icon: Hammer,
    isActive: true,
    items: [
      {
        title: 'Overview',
        url: '/projects',
      },
      {
        title: 'All tickets',
        url: '/all-tickets',
      },
      {
        title: 'Activity',
      },
      {
        title: 'Task list',
      },
      {
        title: 'Archive',
        url: '/archived-projects',
      },
    ],
  },
  {
    title: 'Checklists',

    icon: CheckSquare,
    items: [
      {
        title: 'Templates',
        url: '/templates',
      },
      {
        title: 'My feedback',
        url: '/my-feedback',
      },
    ],
  },
  {
    title: 'Logistics',

    icon: Truck,
    items: [],
  },
  {
    title: 'Warehouse',

    icon: Boxes,
    items: [
      {
        title: 'Storage locations',
        href: `${prev}/inventory`,
      },
      {
        title: 'Search',
        href: `${prev}/inventory/search`,
      },
      {
        title: 'Warehouse Orders',
        href: `${prev}/inventory/lists`,
      },
      {
        title: 'Count requests',
        href: `${prev}/counting-requests`,
      },
      {
        title: 'Low-stock alerts',
      },
    ],
  },
  {
    title: 'Service',

    icon: Wrench,
    items: [
      {
        title: 'My Workorders',
        url: '/my-workorders',
      },
      {
        title: 'Workorders',
        url: '/workorders',
      },
      {
        title: 'Day Planning',
        url: '/day-planning',
      },
      {
        title: 'My Hours',
        url: '/my-hours',
      },
    ],
  },
  {
    title: 'Administration',

    icon: UserCog,
    items: [
      {
        title: 'Accounts',
        url: '/accounts',
        // not hidden: rendered disabled with a tooltip for users without it
        permission: 'USER_ADMIN',
      },
      {
        title: 'Cache',
        url: '/cache',
        permission: 'SYS_ADMIN',
      },
      {
        title: 'Labels',
        url: '/labels',
      },
    ],
  },
];

export default navMenu;
